'use strict'
const Base = require('../base.edit')
// const modal = new (require('../../helpers/modal'))
// const forms = new (require('../../helpers/forms'))

module.exports = class eventDetailWidget extends Base {

	onInit() {

	}

	onDestroy() {
	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/event-detail-szts/event-detail-szts.edit.js
// module id = 446
// module chunks = 0